<template>
  <Banner v-if="showBanner" class="member-banner">
    <div class="member-banner__body">
      <h3>{{ contentBanner.title }}</h3>
      <p class="member-banner__text">
        {{ contentBanner.text }}
      </p>
    </div>
    <div class="member-banner__cta">
      <ShButton
        class="member-banner__link"
        :naked="true"
        :target="contentBanner.cta.target"
        :[btnLinkKey]="contentBanner.cta.url"
      >
        {{ contentBanner.cta.text }}
      </ShButton>
    </div>
  </Banner>
</template>

<script>
import { Banner } from '@sohohouse/design-system'
import { SitecoreApi } from '@/constants/SitecoreApi'
import get from '@/helpers/get'
import { getButtonType } from '~/helpers/get-button-type'
import isEmptyObject from '~/helpers/is-empty-object'
import { ROUTE_SITECORE_JSS } from '~/constants/routes'

export default {
  components: {
    Banner
  },

  data () {
    return {
      contentBanner: {},
      banner: {},
      ROUTE_SITECORE_JSS
    }
  },

  computed: {
    showBanner () {
      return this.banner && !isEmptyObject(this.banner)
    },
    btnLinkKey () {
      return getButtonType(this.contentBanner.cta.url)
    }
  },

  async fetch () {
    const query = 'query ContentData { pageBannerData:item(path:"/sitecore/content/digital-house/Data/Page Banner Data") { ... on PageBannerData { pageBanners:tierChild { name ... on PageBanner { title { value } cta { text url target } text { value } } } } } }'
    const { data: { data } } = await this.$axios.post(SitecoreApi.pageContent, { query })

    this.banner = get(data, ['pageBannerData', 'pageBanners'])
    this.contentBanner = {
      title: get(this.banner, 'title.value', ''),
      text: get(this.banner, 'text.value', ''),
      cta: get(this.banner, 'cta', '')
    }
  },

  fetchOnServer: false
}
</script>

<style lang="scss" scoped>
  .member-banner {
    &__body {
      width: auto;
      justify-content: space-between;

      h3, p {
        color: $color-black;
      }
    }

    &__cta {
      width: max-content;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 0;
      margin-top: $space-040;

      a.member-banner__link {
        color: $color-black;
      }
      @include tablet {
        margin-top: 0;
        margin-left: auto;
        justify-content: flex-end;
      }
    }
  }
</style>
